module.exports = __webpack_public_path__ + "static/media/control tower icon.1a7d1d05.svg";